import React from "react";

export default function Loading() {
  return (
    <div className="loadingDiv">
      <div className="loading"></div>
    </div>
  );
}
